module.exports = __webpack_public_path__ + "assets/power_outage_primary.726e702a.svg";